import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getExpandedItems } from "../../utils/outbound-labels-utils";
import { OrderItemsCell } from "../cells/order-items-cell";

const catalogEntry = fgColumnEntries.quantity;

export const OrderItemsColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  width: catalogEntry.defaultWidth,
  renderNormalCell: ({ row }) => (
    <OrderItemsCell totalItemQuantity={row.totalItemQuantity} />
  ),
  sort: catalogEntry.sortDirection,
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => {
    return (
      <RedoTableTextCell
        text={
          getExpandedItems(row)?.[expansionIndex]?.quantity
            ? String(getExpandedItems(row)?.[expansionIndex]?.quantity)
            : ""
        }
      />
    );
  },
};
